<script setup>
import _ from 'lodash';
import { computed, useAttrs } from 'vue';
import { useDisplay } from 'vuetify';

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    type: {
        type: String,
        default: 'outlined',
    },
    label: String,
    forceLabel: Boolean,
    icon: String,
    color: {
        type: String,
        default: 'secondary',
    },
    kitIcon: String,
    loading: Boolean,
});

const emit = defineEmits(['click']);
const vuetifyDisplay = useDisplay();

const buttonAttributes = computed(() => {
    let attrs = _.clone(useAttrs());
    if (props.type === 'outlined' && (vuetifyDisplay.smAndUp.value || props.forceLabel)) {
        attrs.variant = 'outlined';
    } else if (props.type === 'text' && (vuetifyDisplay.smAndUp.value || props.forceLabel)) {
        attrs.variant = 'text';
    } else if (props.type === 'icon' || (vuetifyDisplay.xs.value && !props.forceLabel)) {
        attrs.icon = true;
        attrs.class = 'rounded-circle';
    }

    if (props.loading) {
        attrs.disabled = true;
    }

    return attrs;
});

const click = () => {
    if (props.loading) return;
    emit('click');
};
</script>

<template>
    <v-btn v-bind="buttonAttributes" :kit-icon="kitIcon" :color="color" :data-cy="$attrs['data-cy']" @click.stop="click">
        <font-awesome-icon v-if="loading" :icon="['far', 'spinner']" size="lg" class="fa-spin" />
        <i v-else-if="kitIcon" :class="'mr-1 fa-kit ' + kitIcon" />
        <font-awesome-icon v-else-if="icon" :icon="['far', icon]" size="lg" :class="{ 'fa-spin': icon === 'spinner' }" />
        <span v-if="!vuetifyDisplay.xs.value || forceLabel" :class="{ 'ml-2': label && icon }" style="margin-top: 2px" v-html="label"></span>
    </v-btn>
</template>
